import { Fragment } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import useFetch from "../../hooks/useFetch";
import { EditEstimate } from "./EditEstimate";
import {urlGetEstimateById} from '../../helpers/urls.js'

export const FetchEditEstimate = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const { data} = useFetch(urlGetEstimateById+ '?id=' + searchParams.get('id'), 'GET');

  return (
      <Fragment>
          {(data) ? <EditEstimate data={data} id={searchParams.get('id')} /> : <CircularProgress />}
      </Fragment>
  )
}